import {lazy} from '@aboutyou/lazy-imports';
import React from 'react';

const StyleSheetManagerLazy = lazy(() =>
  import('./StyleSheetManager.eager').then(mod => ({
    default: mod.StyleSheetManager,
  })),
);

export const ConditionalStyleSheetManager: React.FC<
  React.PropsWithChildren<{isRTL: boolean}>
> = ({children, isRTL}) => {
  if (isRTL) {
    return <StyleSheetManagerLazy>{children}</StyleSheetManagerLazy>;
  }
  return <>{children}</>;
};
